import PastShowsTab from "./sub_tabs/PastShowsTab";


const archiveRouter = {

  past_shows: 
  {
    title: 'Past Shows',
    element: <PastShowsTab />
  }

}

export default archiveRouter;